import Vue from "vue";
export default Vue.extend({
    mounted: function () {
        throw new Error("Test exception");
    },
});
